import React, { useEffect, useState , useRef} from "react";
import "./roombox.css";
import { v4 as uuidv4 } from "uuid";
import { OverlayTrigger, Popover } from "react-bootstrap";
import AdultChildRoomSelector from "./AdultChildRoomSelector";
import SidebarBooking from "./SidebarBooking";
import RoomModalDetails from "./RoomModalDetails";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useLocation, useNavigate } from "react-router-dom";
import { convertISOToDDMMYYYY, convertToISO, convertToISODate, CurrencyFormatter, formatDate, formatDateByLocaleShort, getCurrency, resetToMidnightFormatted } from "../../../helper/Formatter";
import CustModal from "../../../components/Modal/CustModal";
import SwiperThumb from "./SwiperThumb";
import { getBookRates } from "../../../API/rateplanApi";

import generateBookingPayload from "../../../helper/generateBookingPayload";
import Spinner from "../../../components/Spinner";
import TableCompare from "./TableCompare";
import Filter from "./Filter";
import { FaFilter } from "react-icons/fa6";

export default function RoomBox({ defaultDate, selectedDate, apiRoomdata,rateRoomData, policyStoreData, setBookingPayloadState,passDataStoreRoomFun }) {

  console.log('defaultDate::: ', defaultDate);

  const [activeTab, setActiveTab] = useState('whole');

  let locale = localStorage.getItem("Locale");
  let currency = localStorage.getItem("Currency");
  const navigate = useNavigate()
  const location = useLocation()
  const companyName = localStorage.getItem("branchname");
  const loginAuth = localStorage.getItem("LoginAuth");
  const LoginUserId = localStorage.getItem("LoginUserId");
  const LoginUserType = localStorage.getItem("LoginUserType");
  const LoginBranchId = localStorage.getItem("branchid");
  const shortContent = "Short and sweet!";
  const longContent = `
    Very long
    Multiline content
    that is engaging and what-not
  `;
  const hasMounted = useRef(false);
  const uniqueDataId = uuidv4().replace(/-/g, "").substring(0, 24);
  const [isLoading, setLoader] = useState(false);
  const [countRoom, setCountRoom] = useState({});
  const [openModalCompare,setOpenModalCompare] = useState(false);
  const [storeRoomData,setStoreRoomData] = useState([])
  const [clickCompare,setClickCompare] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [guestCounts, setGuestCounts] = useState({
    adults: 0,
    children:  0,
  });
  const [rateAndRoomType, setRateAndRoomType] = useState({});
  const [showPriceTableModal, setShowPriceTableModal] = useState(false);
  const [selectedRateTypeData, setSelectedRateTypeData] = useState({});
  const [showRoomBtn, setShowRoomBtn] = useState(true);
  const [availableRooms, setAvailableRooms] = useState({});
  const [selectedModalRoomData, setSelectedModalRoomData] = useState(null);
  const [totalCost,setTotalCost] = useState(0);
  const [isUpdated, setIsUpdated] = useState(false);
  const [multiSelectData,setMultiSelectData] = useState([])
  const [minimumNight,setMinimumNight] = useState(false)
  const [filterRoom,setFilterRoom] = useState([])
  const [openFilter,setOpenFilter] = useState(false)

  const [bookingPayload, setBookingPayload] = useState({
    customerid: LoginUserId, // MEMBERID
    onModel: LoginUserType,
    deposits: {
      paidamount: null,
    },
    charges: 0, // TOTAL COST
    cost: 0, // TOTAL COST
    taxamount:0,
    checkin: selectedDate?.checkindate != null  && selectedDate?.checkindate != "" ? convertToISO(moment(selectedDate?.checkindate).startOf("day").format("YYYY-MM-DD")) : convertToISO(moment(defaultDate?.todayDate).startOf("day").format("YYYY-MM-DD")),
    checkout: selectedDate?.checkoutdate != null && selectedDate?.checkoutdate != "" ? convertToISO(moment(selectedDate?.checkoutdate).startOf("day").format("YYYY-MM-DD")) : convertToISO(moment(defaultDate?.tomorrowDate).startOf("day").format("YYYY-MM-DD")),
    bookingdetail: {
      occupants: [],
      totalrooms: 0,
      bookingcost: 0, //TOTAL COST
      totaladults: 0,
      totalchildrens: 0,
      extrabed: 0,
      actualcost: 0,
      ratetype: "", //ratetypeid NOT REQUIRED
      discount: 0,
      taxamount:0,
    },
    status: "requested",
    refid: "", //serviceId
    unitid: "", // FIXED VALUE
    ratetypeid: "", //ratetypeid
    bookingdate: convertToISO(moment(defaultDate?.todayDate).startOf("day").format("YYYY-MM-DD")),
    property: {
      documemt: [],
      notes: "no notes",
      ratetypeid: "", //ratetypeid
    },
    bookingtype: "facilitybooking",
  });
  const [initialId, setInitialId] = useState(6740614490);
  const [identifySameRoomBookings, setIdentifySameRoomBookings] = useState([]);//array of

 const nightsCount =  (new Date(bookingPayload?.checkout) - new Date(bookingPayload?.checkin))/ (1000 * 3600 * 24)

  useEffect(() => {
    try {
      setLoader(true)
      setStoreRoomData(rateRoomData);
    } catch (error) {
      setLoader(false)
      console.error('error::: ', error);
    } finally {
      setLoader(false)
    }
  }, [rateRoomData]);


  useEffect(() => {
    let checkIn = "";
    let checkOut = "";
    if(selectedDate?.checkindate != null && selectedDate?.checkoutdate != null && selectedDate?.checkindate != "" && selectedDate?.checkoutdate != ""){
      checkIn = moment(selectedDate?.checkindate).startOf("day").format("YYYY-MM-DD");
      checkOut = moment(selectedDate?.checkoutdate).endOf("day").format("YYYY-MM-DD");
      setBookingPayload(
        generateBookingPayload(
          null,
          {
            // customerid: LoginUserId,
            // checkin: checkInDate,Children
            // checkout: checkOutDate,
            checkin: convertToISO(checkIn),
            checkout: convertToISO(checkOut),
            bookingdate: convertToISO(checkIn),
            // bookingtype: "facilitybooking",
          },
          "firstLayer",
          bookingPayload
        )
      );
    }
    // setCheckInDate(checkIn)
    // setCheckOutDate(checkOut)
    // console.log('checkIn: ', checkIn);
    // console.log('checkOut: ', checkOut);
    // setCheckInDate()
  },[selectedDate?.checkindate, selectedDate?.checkoutdate])


  useEffect(() => {
    let rateRoomType = {}
    // console.log('rateRoomData: ', rateRoomData);
    if(storeRoomData?.length > 0){
      storeRoomData?.forEach((roomRate) => {
        if(roomRate?.ratetypes?.length > 0){
          roomRate?.ratetypes?.forEach((rate) => {
            rateRoomType[roomRate?.serviceId] = {[rate?.ratetypeid] : rate?.ratetypename}
          })
        }
      })
    }
  },[storeRoomData])

  useEffect(() => {
    console.log("countRoom: ", countRoom);
  }, [countRoom]);


  useEffect(() => {
    console.log('bookingPayload: ', bookingPayload);
  },[bookingPayload])

  useEffect(() => {
    // console.log('identifySameRoomBookings: ', identifySameRoomBookings);
  },[identifySameRoomBookings])


  function calculateNights(checkinDate, checkoutDate) {
    const checkin = new Date(checkinDate);
    const checkout = new Date(checkoutDate);
    // Calculate the difference in milliseconds
    const diffTime = checkout - checkin;
    // Convert to days (nights)
    const nights = diffTime / (1000 * 60 * 60 * 24);
    return nights;
  }

  useEffect(() => {
    if(isUpdated){
      console.log("final",bookingPayload);


      const totalNights = calculateNights(bookingPayload?.checkin,bookingPayload?.checkout);


      let payload = bookingPayload?.bookingdetail?.occupants?.map((item) => {
        return {
          _id: item?.refid,
          ratetypeid: item?.ratetype,
          bookingtype: "DAILY",
          quantity: totalNights,
          extrabed: 0,
          discount: 0,
          charges: item?.actualcost,
          uniqueid: item?.unit,
          refid: item?.refid,
          taxamount: item?.taxamount || 0,
          adults: item?.adults,
          childrens: item?.childrens,
          basecost: item?.basecost || 0,
          basecosttax: item?.taxes?.base || 0,
          extraadultcost: item?.extraadultcost || 0,
          extraadultcosttax:  item?.taxes?.ExtraAdult || 0,
          extrachildrencost: item?.extrachildrencost || 0,
          extrachildrencosttax: item?.taxes?.ExtraChild || 0,
          bookingdetails: {
            extraadults: item?.extraAdultCount || 0,
            extrachilds: item?.extraChildCount || 0,
          },
          property:item?.property
        };
      });

      // return
      // const updatedPayload = { ...bookingPayload };

      // updatedPayload.property.ratetypeid =
      //   <up></up>datedPayload.bookingdetail.ratetype;
      // console.log('payload::: ', payload);


      navigate("/" + companyName + "/bookingview/" + "ratetype", {
        state: {
          data: bookingPayload,
          path: location.pathname,
          type: "ratePlanDetail",
          bookingtype: "room",
          payload: payload,
        },
      });


      // navigate("/" + companyName + "/bookingrateplandetail", {
      //   state: {
      //     data: bookingPayload,
      //     path: location.pathname,
      //     type: "ratePlanDetail",
      //   },
      // });
      setIsUpdated(false)
    }
  },[isUpdated, bookingPayload])

  // useEffect(() => {
  //   if(hasMounted.current){
  //     // setBookingPayload(generateBookingPayload(
  //     //   null,
  //     //   {
  //     //     charges:totalCost,
  //     //     cost:totalCost
  //     //   },
  //     //   "firstLayer",
  //     //   bookingPayload
  //     // ))
  //   }else{
  //     hasMounted.current = true;
  //   }
  // },[totalCost])
  useEffect(() => {
    // console.log("Check")
    setIdentifySameRoomBookings([]);
  },[bookingPayload?.checkin, bookingPayload?.checkout])

  useEffect(() => {

    if(hasMounted.current){
      // console.log("called bookingdetaioccupants")
      let totalCost = 0;
      let totalAdults = 0;
      let totalchildren = 0;
      let totalDiscount = 0;
      let totalExtraBed = 0;
      let totalActualCost = 0;
      let totalRoom = 0;
      let totalTaxCost = 0;
      if(bookingPayload?.bookingdetail?.occupants.length > 0){
        // console.log('bookingPayload::: ', bookingPayload);
        totalRoom = bookingPayload?.bookingdetail?.occupants.length;

        bookingPayload?.bookingdetail?.occupants.forEach((booking) => {
            totalCost +=  booking?.actualcost;
            totalAdults +=  booking?.adults;
            totalchildren +=  booking?.childrens;
            totalDiscount +=  booking?.discount;
            totalExtraBed +=  booking?.extrabed;
            totalActualCost +=  booking?.actualcost;
            totalTaxCost += booking?.taxamount;
        })
      }
      setBookingPayload(generateBookingPayload(
        "bookingdetail",
        {
          totalrooms: totalRoom,
          bookingcost: totalCost, //TOTAL COST
          totaladults: totalAdults,
          totalchildrens: totalchildren,
          extrabed: totalExtraBed,
          actualcost: totalActualCost,
          discount: totalDiscount,
          taxamount: totalTaxCost,
          ratetype: bookingPayload?.bookingdetail?.occupants.length > 0 ? bookingPayload?.bookingdetail?.occupants[0].ratetype : "",
        },
        "secondLayer",
        bookingPayload
      ))

    }else{
      hasMounted.current = true;
    }

    // setTotalCost(totalCost)
  },[bookingPayload?.bookingdetail?.occupants])



  const handleBookRoomRatePlan = (payload) => {
    getBookRates(payload);
  };

  const addSelectedRooms = (room, rateType, occupants,defaultAdults,defaultChildren,) => {
    // console.log('room: ratetype, occupants', room, rateType, occupants,defaultAdults,defaultChildren);



    let unitValue = uniqueDataId;
    // setInitialId(unitValue);

    const totalRate = rateType?.rateplans.reduce(
      (acc, ratePlan) => acc + parseFloat(ratePlan?.rate?.Base),
      0
    );

    const extraAdultCost = defaultAdults > 2 ? (defaultAdults - 2) * rateType?.rateplans.reduce((acc, ratePlan) => acc + parseFloat(ratePlan?.rate?.ExtraAdult), 0) : 0;
    const extraChildrenCost = defaultChildren > 1 ? (defaultChildren - 1) * rateType?.rateplans.reduce((acc, ratePlan) => acc + parseFloat(ratePlan?.rate?.ExtraChild), 0) : 0;


    const adultTax = 0;

    const childrenTax = 0;

    const totalBaseTax = rateType?.rateplans.reduce(
      (acc, ratePlan) => acc + parseFloat(ratePlan?.taxes?.Base),
      0
    );

    let dataSetProperty = {
      base_adult_occupancy: room?.property.base_adult_occupancy,
      base_child_occupancy: room?.property.base_child_occupancy,
      max_adult_occupancy: room?.property.max_adult_occupancy,
      max_child_occupancy: room?.property.max_child_occupancy,
      chargetype: room?.property.chargetype
    }

    let bookingInfo = {
      unit: unitValue,
      ratetype: rateType?.ratetypeid,
      roomNotAvailable: false,
      room: 1,
      roomName:room?.name,
      basecost: totalRate,
      rateTypeName:rateType?.ratetypename,
      adults: defaultAdults,
      childrens: defaultChildren,
      extrabed: 0,
      discount: 0,
      taxamount: totalBaseTax,
      taxes: {
        "Base": totalBaseTax,
        "ExtraAdult": adultTax,
        "ExtraChild": childrenTax
      },
      actualcost: totalRate,
      extracost: totalRate, //COST
      extraCost:0,
      balance: 0,
      refid: room?.serviceId, //serviceId
      group: {
        id: "",
        billerid: "", // MEMBERID
        isowner: false,
      },
      extraadultcost: extraAdultCost,
      extrachildrencost: extraChildrenCost,
      property:dataSetProperty
    };

    totalRate.toFixed(2);

    setBookingPayload(
      generateBookingPayload(
        "bookingdetail",
        {
          value:bookingInfo,
          payloadToUpdate:"occupants",
        },
        "toAddDataToThirdLayerForArray",
        bookingPayload
      )
    );
    bookingInfo.ratetypename = rateType?.ratetypename;
    handleIdentifyingOperation(room,rateType,occupants,bookingInfo,"add")
  };

  // Function to update the number of adults for a specific booking
const updateSameBooking = (index, dataToChange) => {
  // console.log(dataToChange,"dataTOchange")
  if (index >= 0 && index < identifySameRoomBookings.length) {
    // Create a new array with the updated booking
    const updatedBookings = [
        ...identifySameRoomBookings.slice(0, index), // Get all bookings before the index
        { ...identifySameRoomBookings[index], adults: dataToChange?.adults, room: dataToChange?.room, childrens: dataToChange?.childrens, actualcost: dataToChange?.actualcost, taxamount: dataToChange?.totalTax }, // Update the specific booking
        ...identifySameRoomBookings.slice(index + 1) // Get all bookings after the index
    ];
    // console.log(updatedBookings,"check")
    setIdentifySameRoomBookings(updatedBookings);
} else {
    console.log("Index out of bounds");
}
}

const handleIdentifyingOperation = (room, rateType, occupants, bookingInfo, operation) => {
  if(identifySameRoomBookings.length > 0){
    let existingBookingIndex = identifySameRoomBookings.findIndex((booking) => booking?.ratetype === rateType?.ratetypeid && booking?.refid === room?.serviceId);
    // console.log('existingBookingIndex: ', existingBookingIndex);
    if(existingBookingIndex != -1){
      if(operation === 'remove'){
        let checkIfLastBooking = identifySameRoomBookings[existingBookingIndex].room
        if(checkIfLastBooking === 1){
          let filteredBookingInfo = identifySameRoomBookings?.filter((booking) => {
            if(booking?.ratetype === rateType?.ratetypeid && booking?.refid === room?.serviceId && booking?.room === 1){
              return false;
            }
            return true;
          }).map((booking) => {
            return booking;
          })
          setIdentifySameRoomBookings(filteredBookingInfo)
          return;
        }
      }
          let operations = doOperationOnBooking(occupants, operation, bookingInfo,existingBookingIndex);
          // console.log('operations11::: ', operations);
          updateSameBooking(existingBookingIndex,{ adults:operations?.adults,room:operations?.room, childrens:operations?.childrens,actualcost:operations?.actualcost, taxamount:operations?.totalTax});
        }else{
          if(operation === "remove"){
            return "No booking to remove";
          }
          if(operation === "update"){
            return "No booking to update";
          }
          // sameTypeBookings.push(booking);
          if(operation === "add"){
            setIdentifySameRoomBookings((prev) => [...prev, bookingInfo]);
          }
        }
    }else{
      if(operation === "add"){
        setIdentifySameRoomBookings([bookingInfo])
      }
    }
}

const doOperationOnBooking = (occupants, operation, bookingInfo, existingBookingIndex) => {
  // console.log(occupants, operation, existingBookingIndex, identifySameRoomBookings[existingBookingIndex], "check1");

  let changeInAdults = identifySameRoomBookings[existingBookingIndex].adults
    ? operation === "add"
      ? identifySameRoomBookings[existingBookingIndex].adults + (occupants?.adults || 0)
      : operation === "remove"
        ? identifySameRoomBookings[existingBookingIndex].adults - (occupants?.adults || 0)
        : operation === "update"
          ? identifySameRoomBookings[existingBookingIndex].adults + (occupants?.adults || 0) - (bookingInfo?.adults || 0)
          : 0
    : 0;

  let changeInRooms = identifySameRoomBookings[existingBookingIndex].room
    ? operation === "add"
      ? identifySameRoomBookings[existingBookingIndex].room + 1
      : operation === "remove"
        ? identifySameRoomBookings[existingBookingIndex].room - 1
        : operation === "update"
          ? identifySameRoomBookings[existingBookingIndex].room
          : 0
    : 0;

  let changeInChildren = identifySameRoomBookings[existingBookingIndex]?.childrens ?? 0;

  if (operation === "add") {
    changeInChildren += occupants?.children || 0;
  } else if (operation === "remove") {
    changeInChildren -= occupants?.children || 0;
  } else if (operation === "update") {
    changeInChildren += (occupants?.children || 0) - (bookingInfo?.childrens || 0);
  }

  console.log('changeInChildren::: ', changeInChildren);

  let changeInActualCost = identifySameRoomBookings[existingBookingIndex].actualcost
    ? operation === "add"
      ? identifySameRoomBookings[existingBookingIndex].actualcost + (bookingInfo?.actualcost || 0)
      : operation === "remove"
        ? identifySameRoomBookings[existingBookingIndex].actualcost - (bookingInfo?.actualcost || 0)
        : operation === "update"
          ? identifySameRoomBookings[existingBookingIndex].actualcost + (occupants?.actualcost || 0) - (bookingInfo?.actualcost || 0)
          : 0
    : 0;

  let changeInTotalTax = identifySameRoomBookings[existingBookingIndex].taxamount
    ? operation === "add"
      ? identifySameRoomBookings[existingBookingIndex].taxamount + (bookingInfo?.taxamount || 0)
      : operation === "remove"
        ? identifySameRoomBookings[existingBookingIndex].taxamount - (bookingInfo?.taxamount || 0)
        : operation === "update"
          ? identifySameRoomBookings[existingBookingIndex].taxamount + (occupants?.taxamount || 0) - (bookingInfo?.taxamount || 0)
          : 0
          : 0;

  return {
    adults: changeInAdults,
    childrens: changeInChildren,
    actualcost: changeInActualCost,
    totalTax: changeInTotalTax,
    room: changeInRooms
  };
}


  const handlePlus = (room, rateType) => {
    // console.log('room::: ', room);

    if (room?.minnights && nightsCount < room.minnights) {
      setMinimumNight(true);
      // Optionally show a toast
      // toast.warn(`Minimum nights should be ${room.minnights}`, { autoClose: 1000 });
      return;
    }

    const countKey = `${room?.serviceId}-${rateType?.ratetypename}`;
    const roomCount = `${room?.serviceId}`;
    setGuestCounts({
      adults: room?.property.base_adult_occupancy,
      children: room?.property.base_child_occupancy
    });

    const defaultAdults = room?.property.base_adult_occupancy
    const defaultChildren = room?.property.base_child_occupancy

    const available = availableRooms[roomCount] ?? room?.units;

    // Prevent adding a room if no rooms are available
    if (available <= 0) {
      toast.warn("No more rooms available!", { autoClose: 1000 });
      return;
    }

    setCountRoom((prev) => {
      const currentCount = prev[countKey] || 0;
      const newCount = currentCount + 1;

      // Update the available rooms
      setAvailableRooms((prevAvailable) => ({
        ...prevAvailable,
        [roomCount]: available - 1,
      }));

      // Hide the Add Room button if the count is greater than 0
      setShowRoomBtn((prevBtns) => ({
        ...prevBtns,
        [countKey]: newCount === 0,
      }));

      return { ...prev, [countKey]: newCount };
    });
    addSelectedRooms(room, rateType, guestCounts , defaultAdults , defaultChildren);
  };



  // Function to handle the count decrement
  const handleMinus = (room, rateType) => {
    const countKey = `${room?.serviceId}-${rateType?.ratetypename}`;
    const roomCount = `${room?.serviceId}`;

    setCountRoom((prev) => {
      const currentCount = prev[countKey] || 0;

      // Prevent decrementing if no rooms are added
      if (currentCount === 0) {
        return prev;
      }

      const newCount = currentCount - 1;

      // Restore the available rooms
      setAvailableRooms((prevAvailable) => ({
        ...prevAvailable,
        [roomCount]: (prevAvailable[roomCount] ?? 0) + 1,
      }));

      // Show the "Add Room" button if the count is 0
      setShowRoomBtn((prevBtns) => ({
        ...prevBtns,
        [countKey]: newCount === 0,
      }));

      // Remove the room from the booking payload
      let currentBookingCount = currentCount;
      let bookingToRemove = {};
      const filteredBookingInfo = bookingPayload?.bookingdetail?.occupants.filter((occupant) => {
        if (occupant?.ratetype === rateType?.ratetypeid && occupant?.refid === room?.serviceId) {
          if (currentBookingCount === 1) {
            bookingToRemove = occupant;
            return false;
          }
          currentBookingCount--;
        }
        return true;
      });

      setBookingPayload(
        generateBookingPayload(
          "bookingdetail",
          { payloadToUpdate: "occupants", value: filteredBookingInfo },
          "toReplaceDataToThirdLayerForArray",
          bookingPayload
        )
      );

      handleIdentifyingOperation(
        room,
        rateType,
        { adults: bookingToRemove?.adults, children: bookingToRemove?.childrens },
        bookingToRemove,
        "remove"
      );

      return { ...prev, [countKey]: newCount };
    });
  };

  const handleAddRoom = (room, rateType) => {
    // console.log('room::: ', room);
    if (room?.minnights && nightsCount < room.minnights) {
      setMinimumNight(true);
      // Optionally show a toast
      toast.warn(`Please add  ${room?.minnights - nightsCount} more night to book`, { autoClose: 1000 });
      return;
    }

    const countKey = `${room?.serviceId}-${rateType?.ratetypename}`;
    const roomCount = `${room?.serviceId}`;

    const available = availableRooms[roomCount] ?? room?.units;

    // Check if the room is available
    if (available <= 0) {
      toast.warn("No more rooms available!", { autoClose: 1000 });
      return;
    }

    setShowRoomBtn((prevBtns) => ({
      ...prevBtns,
      [countKey]: false, // Hide the button
    }));

    handlePlus(room, rateType); // Increment the count
  };

  function handleMoreDetails(params) {
    setShowModal(true);
    setSelectedModalRoomData(params)
  }

  function handleMoreDetailsClose() {
    setShowModal(false);
  }

  function formatCurrency(amount) {
    return `₹ ${parseFloat(amount).toLocaleString("en-IN")}`;
  }

  function handleOpenRateModal(data) {
    setShowPriceTableModal(true);
    setSelectedRateTypeData(data);
  }

  const handleRoomDataUpdate = (room, rateType, index, data, occupant) => {
    // console.log("handleRoomData",room, rateType, index, data, occupant);

      if(occupant?.refid === room?.serviceId && occupant?.ratetype === rateType?.ratetypeid) {
        let extraAdultCharge = 0;
        let extraChildrenCharge = 0;
        let extraAdultTaxCharge = 0;
        let extraChildrenTaxCharge = 0;
        let adultPriceIncrease = false;
        let adultPriceDecrease = false;
        let childrenPriceIncrease = false;
        let childrenPriceDecrease = false;
        let priceToAdd = 0;
        if(data?.adults > guestCounts?.adults){
          // console.log(data?.adults - guestCounts?.adults,"Count")
          if(data?.adults > 1){
            extraAdultCharge = data?.adults - guestCounts?.adults;
            adultPriceIncrease = true;
          }
        }else{
          adultPriceDecrease = true;
        }
        if(data?.children > guestCounts?.children){
          // console.log(data?.children - guestCounts?.children,"Count")
          if(data?.children > 0){
            extraChildrenCharge = data?.children - guestCounts?.children;
            childrenPriceIncrease = true;
          }
        }else{
          childrenPriceDecrease = true;
        }


        priceToAdd = rateType?.rateplans.reduce((accumulator,rate) => {
          let extraCost = 0;
          // let totalTax = 0;
          // let extraAdultTaxCharge = 0;
          // let extraChildrenTaxCharge = 0;
          accumulator.totalBaseTax += rate?.taxes?.Base;
          if (adultPriceIncrease && childrenPriceIncrease) {
              extraCost = (extraAdultCharge * rate?.rate?.ExtraAdult) + (extraChildrenCharge * rate?.rate?.ExtraChild);
              accumulator.total += rate?.rate?.Base + extraCost;
              accumulator.extraAdultTax += extraAdultCharge * rate?.taxes?.ExtraAdult;
              accumulator.extraChildrenTax += extraChildrenCharge * rate?.taxes?.ExtraChild;
              accumulator.totalTax += rate?.taxes?.Base + (extraAdultCharge*rate?.taxes?.ExtraAdult) + (extraChildrenCharge * rate?.taxes?.ExtraChild);
              accumulator.extraAdultCost += extraAdultCharge * rate?.rate?.ExtraAdult;
              accumulator.extraChildrenCost += extraChildrenCharge * rate?.rate?.ExtraChild;
          }
          if (adultPriceIncrease && childrenPriceDecrease) {
              extraCost = extraAdultCharge * rate?.rate?.ExtraAdult;
              accumulator.total += rate?.rate?.Base + extraCost;
              accumulator.extraAdultTax += extraAdultCharge * rate?.taxes?.ExtraAdult;
              accumulator.totalTax += rate?.taxes?.Base + (extraAdultCharge*rate?.taxes?.ExtraAdult);
              accumulator.extraAdultCost += extraAdultCharge * rate?.rate?.ExtraAdult;
          }
          if (adultPriceDecrease && childrenPriceIncrease) {
              extraCost = extraChildrenCharge * rate?.rate?.ExtraChild;
              accumulator.total += rate?.rate?.Base + extraCost;
              accumulator.extraChildrenTax += extraChildrenCharge * rate?.taxes?.ExtraChild;
              accumulator.totalTax += rate?.taxes?.Base + (extraChildrenCharge * rate?.taxes?.ExtraChild);
              accumulator.extraChildrenCost += extraChildrenCharge * rate?.rate?.ExtraChild;
          }
          if (adultPriceDecrease && childrenPriceDecrease) {
              accumulator.total += rate?.rate?.Base;
              accumulator.totalTax += rate?.taxes?.Base;
              extraCost = 0;
          }

          // Update the extraCost in the accumulator
          accumulator.extraCost += extraCost;

          return accumulator;

        },{total:0, extraCost:0, extraAdultTax:0, extraChildrenTax:0, totalTax:0, totalBaseTax :0, extraAdultCost:0, extraChildrenCost:0})


          setBookingPayload(generateBookingPayload("bookingdetail",{
            allValuesToUpdate:{
              "adults":data?.adults,
              "childrens":data?.children,
              "actualcost":priceToAdd?.total,
              "extracost": priceToAdd?.total,
              "basecost": priceToAdd?.total,
              "extraCost": priceToAdd?.extraCost,
              "taxamount":priceToAdd?.totalTax,
              "taxes":{
                "Base": priceToAdd?.totalBaseTax,
                "ExtraAdult":priceToAdd?.extraAdultTax,
                "ExtraChild" : priceToAdd?.extraChildrenTax
              },
              "extraadultcost": priceToAdd?.extraAdultCost,
              "extrachildrencost": priceToAdd?.extraChildrenCost,
              "extraAdultCount": extraAdultCharge,
              "extraChildCount": extraChildrenCharge
            },payloadToUpdate:"occupants", valueToUpdateOf:occupant.unit
          },"toAlterDataToThirdLayerForArray",bookingPayload))

          handleIdentifyingOperation(room, rateType, {"adults":data?.adults, "children":data?.children, "actualcost" : priceToAdd?.total, "extracost": priceToAdd?.total,"basecost": priceToAdd?.total, "extraCost":priceToAdd?.extraCost, "taxamount":priceToAdd?.totalTax, "extraadultcost": priceToAdd?.extraAdultCost, "extrachildrencost": priceToAdd?.extraChildrenCost, "extraAdultCount": extraAdultCharge, "extraChildCount": extraChildrenCharge}, occupant,"update")

      }
  };

  async function handleOnBook() {


    if(bookingPayload?.bookingdetail?.occupants.length > 0){
     let totalCost = bookingPayload?.bookingdetail?.occupants.reduce((total,booking) => {
        total.totalCost += booking?.actualcost;
        total.totalTax += booking?.taxamount;
        return total;
      },{totalCost :0, totalTax:0})
      let payload = {};
      payload.charges = totalCost?.totalCost;
      payload.cost = totalCost?.totalCost;
      payload.taxamount = totalCost?.totalTax;
      if(bookingPayload?.bookingdetail?.occupants.length > 0){
        payload.unitid = bookingPayload?.bookingdetail?.occupants?.[0]?.unit;
        payload.refid = bookingPayload?.bookingdetail?.occupants?.[0]?.refid;
        payload.ratetypeid = bookingPayload?.bookingdetail?.occupants?.[0]?.ratetype;
      }

      setBookingPayload(generateBookingPayload(
        null,payload,
        "firstLayer",
        bookingPayload
      ))



      setIsUpdated(true)
  } else {
      toast.warn("Please add room ",{autoClose:1000});
    }

    // if (LoginUserId) {
    //   await handleBookRoomRatePlan(bookingPayload).then((res) => {
    //     console.log("res::: ", res);
    //   });
    // } else {
    //   toast.warn("Please login to book room");
    // }
  }


  // console.log(':::nigts ',   (new Date(bookingPayload?.checkout) - new Date(bookingPayload?.checkin))/ (1000 * 3600 * 24));


  const handleCheckBoxChange = (room, countKey) => {
    setClickCompare((prev) => {
      const alreadyAdded = prev.find((r) => r.countKey === countKey);

      if (alreadyAdded) {
        // Uncheck: Remove from list
        return prev.filter((r) => r.countKey !== countKey);
      }

      if (prev.length >= 4) {
        toast.warn("You can only compare up to 4 rooms.", { autoClose: 1000 });
        return prev; // No change
      }

      // Check: Add to list
      return [...prev, { ...room, countKey }];
    });
  };

  const openModalClickToCompare = () => {
    if (clickCompare.length >= 2) {
      setOpenModalCompare(true);
    }else{
      toast.warn("Please select at least two rooms to compare.", { autoClose: 1000 });
    }
  };

  function handleCloseModalCompare(){
    setOpenModalCompare(false)
    setClickCompare([])
  }

  function handlePassMultiCheckBox(updatedSelected) {
    // console.log('filterRoomIds-1::: ', updatedSelected);

    const result = storeRoomData?.map((item) => {
        const amenityCodes = item?.amenities.map((a) => a.code);
        // console.log('filterRoomIds-2::: ', amenityCodes);

        const hasAllSelected = updatedSelected.every((code) =>
          amenityCodes.includes(code)
      );
      // console.log('filterRoomIds-3::: ', hasAllSelected);

      // console.log('filterRoomIds-4 ', item.amenities.filter((amenity) => updatedSelected.includes(amenity.code)));
        return hasAllSelected
          ? {...item,matchedAmenities: item.amenities.filter((amenity) => updatedSelected.includes(amenity.code)),}
          : null;
      })
      .filter(Boolean); // Remove null entries

    setMultiSelectData(result);
  }

  function handleFilter() {
    setOpenFilter(true);
    setStoreRoomData(apiRoomdata || rateRoomData);
    setFilterRoom([])
    setMultiSelectData([]);
  }
  function handleFilterRooms(e) {
    let filteredRooms = storeRoomData?.filter((item) => item?.serviceId === e?.value);
    setFilterRoom(filteredRooms);
  }


  function handleApply() {

    const hasFilterRoom = Array.isArray(filterRoom) && filterRoom.length > 0;
    const hasMultiSelect = Array.isArray(multiSelectData) && multiSelectData.length > 0;

    if (hasFilterRoom && hasMultiSelect) {
      const filterRoomIds = filterRoom.map(item => item?.serviceId);
      // console.log('filterRoomIds::: ', filterRoomIds);
      const multiSelectIds = multiSelectData.map(item => item?.serviceId);
      // console.log('filterRoomIds1::: ', multiSelectIds);

      const commonIds = filterRoomIds.filter(id => multiSelectIds.includes(id));
      console.log('mergedData0::: ', commonIds);

      if (commonIds.length > 0) {
        // Merge both arrays based on serviceId, giving priority to filterRoom
        const mergedData = [
          ...multiSelectData,
          ...filterRoom.filter(
            item => !multiSelectIds.includes(item?.serviceId)
          ),
        ];

        const matchedCommonData = mergedData.filter(item =>
          commonIds.includes(item?.serviceId)
        );

        console.log('matchedCommonData::: ', matchedCommonData);
        // i want to this id from this mergedData so how to do it




        console.log('mergedData::: ', mergedData);
        setStoreRoomData(matchedCommonData);
        passDataStoreRoomFun(matchedCommonData);
        setOpenFilter(false);

      } else {
        toast.error("No room found", { autoClose: 1500 });
        setStoreRoomData([]);
        passDataStoreRoomFun([]);
        setOpenFilter(false);

      }

    } else {
      // Fallback: choose whichever is non-empty (or empty if both are)
      const fallbackData = hasFilterRoom ? filterRoom : hasMultiSelect ? multiSelectData : [];


      if (fallbackData.length === 0) {
        toast.warn("No rooms found", { autoClose: 1500 });
      }

      setStoreRoomData(fallbackData);
      passDataStoreRoomFun(fallbackData);
    }

    setOpenFilter(false);
  }

  function handleCompareRooms() {
    if (clickCompare.length >= 2) {
      setOpenModalCompare(true);
    }else{
      toast.warn("Please select at least two rooms to compare.", { autoClose: 1000 });
    }
  }


  console.log('storeRoomData::: ', storeRoomData);
  return (
    <>
      {isLoading && <Spinner />}
      <div>
        <div className="mt-3 p-3 border rounded ">
          <div className="d-flex border rounded align-content-center tabs_container_room">
            <button className="btn_filter" onClick={handleFilter}><FaFilter /> Filter</button>
            <button className="compare_roms_btn" onClick={handleCompareRooms}> Compare rooms</button>
            <p className="">Show Price &nbsp;:</p>
            <button
              className={`flex-fill btn tab_btn_room tab_btn_room1  ${
                activeTab === "night" ? "active" : ""
              }`}
              onClick={() => setActiveTab("night")}
            >
              Per Room Per Night
            </button>
            <button
              className={`flex-fill btn tab_btn_room ${
                activeTab === "whole" ? "active" : ""
              }`}
              onClick={() => setActiveTab("whole")}
            >
              Price For Whole Stay
            </button>
          </div>
          <div className="d-flex">



          <>

            {activeTab === "night" && (
              <>
                <div className="outside_room_box_container flex-column p-3">
                  {storeRoomData?.map((room, roomIndex) => {
                    let totalRoomUnitAvailable = room?.units;
                    const roomImgs =
                      room?.gallery?.map((img) => img?.attachment) || [];

                    const amenitiesArray =
                      Array.isArray(room?.amenities) &&
                      room.amenities.length > 0
                        ? room.amenities.map(
                            (amenity) => amenity?.name || "Unknown Amenity"
                          )
                        : "No amenities";

                    const { adult, child } = room?.capacity || {
                      adult: 0,
                      child: 0,
                    };

                    return (
                      <div
                        className="room_box_container p-3 mb-3"
                        key={room.serviceId}
                      >
                        <div className="room_inside_box_container">
                          <div className="room_img_container">
                            {roomImgs?.length > 0 ? (
                              <SwiperThumb roomImgs={roomImgs} />
                            ) : (
                              <img
                                src={"/images/no-image.jpg"}
                                alt="room_img"
                              />
                            )}
                          </div>
                          <p className="room_title_text">{room?.name}</p>

                          {/* <ul className="all_amentities_container">
                    {amenitiesArray === "No amenities" ? (
                      <li>No amenities</li>
                    ) : (
                      amenitiesArray.map((item, i) => <li key={i}>➭ {item}</li>)
                    )}
                  </ul> */}

                          {/* <button
                    className="more_details_btn"
                    onClick={() => handleMoreDetails(room)}
                  >
                    More details
                  </button> */}
                        </div>

                        {/* repeated box */}
                        <div className="room_rate_plan_container">
                          {/* <p className="rate_plan_text">Rate Plans</p> */}
                          {room?.ratetypes?.map((rateType, rateTypeIndex) => {
                            // console.log('rateType::: ', rateType);
                            const countKey = `${room?.serviceId}-${rateType?.ratetypename}`;
                            // console.log('countKey::: ', countKey);

                            const roomQuantityCount = countRoom[countKey] || 0;

                            const nightsPerDateCount = rateType?.rateplans?.map(
                              (item) => item
                            );

                            const specialhighlightinclusion =
                              rateType?.rateplans?.map(
                                (item) => item?.specialhighlightinclusion
                              );

                            // const totalRate = rateType?.rateplans.reduce(
                            //   (acc, ratePlan) => acc + parseFloat(ratePlan?.rate?.Base),
                            //   0
                            // );
                            // totalRate.toFixed(2); // total rates for day

                            const currentBookingInfo =
                              bookingPayload?.bookingdetail?.occupants?.reduce(
                                (accumulator, occupant) => {
                                  if (
                                    occupant?.ratetype ===
                                      rateType?.ratetypeid &&
                                    occupant?.refid === room?.serviceId
                                  ) {
                                    accumulator.actualCost +=
                                      occupant?.actualcost;
                                    accumulator.adults += occupant?.adults;
                                    accumulator.children += occupant?.childrens;
                                    accumulator.totalTax += occupant?.totaltax;
                                    accumulator.total += 1;
                                  }
                                  return accumulator;
                                },
                                {
                                  total: 0,
                                  actualCost: 0,
                                  adults: 0,
                                  children: 0,
                                  totalTax: 0,
                                }
                              );

                            const adults =
                              currentBookingInfo?.adults > 0
                                ? currentBookingInfo.adults
                                : room?.property?.base_adult_occupancy ||
                                  guestCounts.adults;

                            const children =
                              room?.minnights > nightsCount
                                ? 0
                                : currentBookingInfo?.children > 0
                                ? currentBookingInfo.children
                                : room?.property?.base_child_occupancy ||
                                  guestCounts.children;

                            const rooms = currentBookingInfo?.total || 1;

                            // console.log(currentBookingInfo,"currentBookingTOtalRate")
                            return (
                              <div
                                key={`${roomIndex}-${rateTypeIndex}`}
                                className="room_rate_card_container_outsider mb-2"
                              >
                                <>
                                  <p className="m-0 room_rate_name_text">
                                    {Array.from(
                                      new Set(
                                        rateType?.rateplans
                                          ?.map((plan) => plan?.title)
                                          .filter(Boolean)
                                      )
                                    ).join(", ") || "No Title"}
                                  </p>

                                  {/* <p className="room_units_text">
                          {totalRoomUnitAvailable
                            ? `${totalRoomUnitAvailable} units available`
                            : "No units available"}
                        </p> */}
                                  <div className="room_rate_card_container">
                                    <div
                                      className="col-md-6 p-0 "
                                      style={{ position: "relative" }}
                                    >
                                      {/* <p className="room_rate_text_self">
                                Room maximum capacity
                              </p>
                              <div className="img_adult_child_container">
                                <i className="fa fa-male" aria-hidden="true" />{" "}
                                <span>{adult} </span>
                                <i className="fa fa-solid fa-child" />
                                <span>{child}</span>
                              </div> */}

                                      {/* <div
                                style={{
                                  height:
                                    showRoomBtn[countKey] !== false ? 200 : 100,
                                }}
                              ></div> */}

                                      {currentBookingInfo?.total > 0 ? (
                                        <>
                                          <p className="room_rate_text_self mt-5">
                                            Room
                                          </p>

                                          <div className="quantity_container">
                                            <button
                                              className="minus_btn"
                                              onClick={() =>
                                                handleMinus(room, rateType)
                                              }
                                            >
                                              -
                                            </button>
                                            <p>{roomQuantityCount}</p>
                                            <button
                                              className="plus_btn"
                                              disabled={
                                                roomQuantityCount >=
                                                totalRoomUnitAvailable
                                              } // Disable if limit reached
                                              onClick={() =>
                                                handlePlus(room, rateType)
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        </>
                                      ) : null}

                                      <div className="popover_container">
                                        {/* <p
                                  className="free_cancallation_btn"
                                  // onMouseEnter={() => setIsHovered(true)}
                                  // onMouseLeave={() => setIsHovered(false)}
                                >
                                  Room Rates Exclusive of Tax
                                </p> */}
                                        {/* {showRoomBtn[countKey] !== false && <br/> } */}

                                        {isHovered && (
                                          <div className="popover_hover_box">
                                            <p
                                              className="popover_text"
                                              dangerouslySetInnerHTML={{
                                                __html: `This booking is non-refundable and the tariff cannot be cancelled with zero fee.`,
                                              }}
                                            ></p>
                                          </div>
                                        )}
                                      </div>
                                      <p
                                        className="free_cancallation_btn"
                                        // onMouseEnter={() => setIsHovered(true)}
                                        // onMouseLeave={() => setIsHovered(false)}
                                      >
                                        Room Rates Exclusive of Tax
                                      </p>
                                      <p className="special_highlight_txt">
                                        {/* {room?.specialhighlightinclusion} */}
                                        {specialhighlightinclusion}
                                      </p>
                                      <button
                                        className={
                                          showRoomBtn[countKey] !== false
                                            ? "more_details_btn more_details_btn1"
                                            : "more_details_btn"
                                        }
                                        onClick={() => handleMoreDetails(room)}
                                      >
                                        Room Info
                                      </button>
                                      <br />
                                      <label>
                                        <input
                                          checked={clickCompare.some((r) => r.countKey === countKey)}
                                          disabled={
                                            clickCompare.length >= 4 &&
                                            !clickCompare.some(
                                              (r) =>
                                                r?.countKey === countKey
                                            )
                                          }
                                          type="checkbox"
                                          id="myCheckbox"
                                          onChange={() =>
                                            handleCheckBoxChange(room, countKey)
                                          }
                                        />
                                        &nbsp;
                                      </label>
                                      {clickCompare.some(
                                      (r) => r.countKey === countKey
                                    ) ? (
                                      <span
                                        style={{ fontSize: 14,color:"green",fontWeight:"500",cursor:"pointer" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openModalClickToCompare(room);
                                        }}
                                      >
                                        Click to compare
                                      </span>
                                    ) : (
                                      <span
                                        style={{ fontSize: 14,cursor:"pointer" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openModalClickToCompare(room);
                                        }}
                                      >
                                        Add to compare
                                      </span>
                                    )}
                                    </div>

                                    <div className="col-md-6 p-0 price_night_adult_child_container">
                                      <div className="price_rate_total_adult_per_night_container">
                                        <p>
                                          {getCurrency()}&nbsp;
                                          {CurrencyFormatter(
                                            activeTab === "night"
                                              ? (currentBookingInfo?.actualCost >
                                                0
                                                  ? currentBookingInfo.actualCost /
                                                    nightsCount
                                                  : rateType?.rateplans.reduce(
                                                      (acc, ratePlan) =>
                                                        acc +
                                                        parseFloat(
                                                          ratePlan?.rate?.Base
                                                        ),
                                                      0
                                                    ) / nightsCount
                                                ).toFixed(2)
                                              : currentBookingInfo?.actualCost >
                                                0
                                              ? currentBookingInfo.actualCost.toFixed(
                                                  2
                                                )
                                              : rateType?.rateplans
                                                  .reduce(
                                                    (acc, ratePlan) =>
                                                      acc +
                                                      parseFloat(
                                                        ratePlan?.rate?.Base
                                                      ),
                                                    0
                                                  )
                                                  .toFixed(2),
                                            locale || "en-IN",
                                            currency || "INR"
                                          )}
                                          &nbsp;
                                          {/* <div className="popover_container"> */}
                                          <button
                                            className="free_cancallation_btn"
                                            onClick={() =>
                                              handleOpenRateModal(rateType)
                                            }
                                            // onMouseEnter={() => setHoverPrice(true)}
                                            // onMouseLeave={() => setHoverPrice(false)}
                                          >
                                            <i
                                              className="fa fa-info-circle"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        </p>
                                        {nightsPerDateCount?.length && (
                                          <p className="price_per_night_text">
                                            Price For Per Night
                                          </p>
                                        )}
                                        <p>{`${adults} Adults, ${children}  ${
                                          room?.minnights > nightsCount
                                            ? "Child"
                                            : "Children"
                                        }, ${rooms} Room`}</p>
                                      </div>
                                      {/* {countRoom && countRoom[`${room?.serviceId}-${rateType?.ratetypename}`] < 0 && ( */}

                                      {showRoomBtn[countKey] !== false && (
                                        <button
                                          className="add_room_btn recommended_txt"
                                          onClick={() =>
                                            handleAddRoom(room, rateType)
                                          }
                                        >
                                          Add Room
                                        </button>
                                      )}

{room?.minnights > nightsCount && (
                                      <p className="mb-0 mt-2 text-danger font-14 ">
                                        {`You need ${
                                          room?.minnights - nightsCount
                                        } more night to book this room.`}
                                      </p>
                                    )}

                                      {/* {room?.minnights > nightsCount && (
                                        <p className="mb-0 mt-2 text-danger font-14 ">
                                          Please add {room?.minnights} night to
                                          your booking
                                        </p>
                                      )} */}

                                      {/* )} */}

                                      <p className="room_available_text">
                                      {availableRooms[countKey?.slice(0, 24)] ??
                                        totalRoomUnitAvailable}
                                      &nbsp;
                                      {totalRoomUnitAvailable > 1
                                        ? "Rooms"
                                        : "Rooms"}{" "}
                                      available
                                    </p>

                                      {/* <p className="room_available_text">
                                        {availableRooms[
                                          countKey?.slice(0, 24)
                                        ] ?? totalRoomUnitAvailable}
                                        &nbsp; rooms available
                                      </p> */}
                                    </div>
                                  </div>

                                  <div className="room_adult_child_container">
                                    {bookingPayload?.bookingdetail?.occupants
                                      ?.filter((occupant) => {
                                        if (
                                          occupant?.ratetype !==
                                            rateType?.ratetypeid ||
                                          occupant?.refid !== room?.serviceId
                                        ) {
                                          return false;
                                        }
                                        return true;
                                      })
                                      .map((occupant, index) => {
                                        return (
                                          <AdultChildRoomSelector
                                            key={occupant?.unitid}
                                            bookingInfo={occupant}
                                            roomName={`Room ${index + 1}`}
                                            maxAdults={
                                              room?.property
                                                ?.max_adult_occupancy ??
                                              room?.capacity?.adult ??
                                              0
                                            }
                                            maxChildren={
                                              room?.property
                                                ?.max_child_occupancy ??
                                              room?.capacity?.child ??
                                              0
                                            }
                                            onChange={(data) =>
                                              handleRoomDataUpdate(
                                                room,
                                                rateType,
                                                index,
                                                data,
                                                occupant
                                              )
                                            }
                                          />
                                        );
                                      })}
                                  </div>
                                  <hr className="m-0" />
                                </>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
            {activeTab === "whole" && (
              <div className="outside_room_box_container flex-column p-3">
                {storeRoomData?.map((room, roomIndex) => {
                  let totalRoomUnitAvailable = room?.units;
                  const roomImgs =
                    room?.gallery?.map((img) => img?.attachment) || [];

                  const amenitiesArray =
                    Array.isArray(room?.amenities) && room.amenities.length > 0
                      ? room.amenities.map(
                          (amenity) => amenity?.name || "Unknown Amenity"
                        )
                      : "No amenities";

                  const { adult, child } = room?.capacity || {
                    adult: 0,
                    child: 0,
                  };

                  return (
                    <div
                      className="room_box_container p-3 mb-3"
                      key={room.serviceId}
                    >
                      <div className="room_inside_box_container">
                        <div className="room_img_container">
                          {roomImgs?.length > 0 ? (
                            <SwiperThumb roomImgs={roomImgs} />
                          ) : (
                            <img src={"/images/no-image.jpg"} alt="room_img" />
                          )}
                        </div>
                        <p className="room_title_text">{room?.name}</p>

                        {/* <ul className="all_amentities_container">
                    {amenitiesArray === "No amenities" ? (
                      <li>No amenities</li>
                    ) : (
                      amenitiesArray.map((item, i) => <li key={i}>➭ {item}</li>)
                    )}
                  </ul> */}

                        {/* <button
                    className="more_details_btn"
                    onClick={() => handleMoreDetails(room)}
                  >
                    More details
                  </button> */}
                      </div>

                      {/* repeated box */}
                      <div className="room_rate_plan_container">
                        {/* <p className="rate_plan_text">Rate Plans</p> */}
                        {room?.ratetypes?.map((rateType, rateTypeIndex) => {
                          const countKey = `${room?.serviceId}-${rateType?.ratetypename}`;

                          const roomQuantityCount = countRoom[countKey] || 0;

                          const nightsPerDateCount = rateType?.rateplans?.map(
                            (item) => item
                          );

                          const specialhighlightinclusion =
                            rateType?.rateplans?.map(
                              (item) => item?.specialhighlightinclusion
                            );

                          // const totalRate = rateType?.rateplans.reduce(
                          //   (acc, ratePlan) => acc + parseFloat(ratePlan?.rate?.Base),
                          //   0
                          // );
                          // totalRate.toFixed(2); // total rates for day

                          const currentBookingInfo =
                            bookingPayload?.bookingdetail?.occupants?.reduce(
                              (accumulator, occupant) => {
                                if (
                                  occupant?.ratetype === rateType?.ratetypeid &&
                                  occupant?.refid === room?.serviceId
                                ) {
                                  accumulator.actualCost +=
                                    occupant?.actualcost;
                                  accumulator.adults += occupant?.adults;
                                  accumulator.children += occupant?.childrens;
                                  accumulator.totalTax += occupant?.totaltax;
                                  accumulator.total += 1;
                                }
                                return accumulator;
                              },
                              {
                                total: 0,
                                actualCost: 0,
                                adults: 0,
                                children: 0,
                                totalTax: 0,
                              }
                            );

                          const adults =
                            currentBookingInfo?.adults > 0
                              ? currentBookingInfo.adults
                              : room?.property?.base_adult_occupancy ||
                                guestCounts.adults;

                          const children =
                            room?.minnights > nightsCount
                              ? 0
                              : currentBookingInfo?.children > 0
                              ? currentBookingInfo.children
                              : room?.property?.base_child_occupancy ||
                                guestCounts.children;

                          const rooms = currentBookingInfo?.total || 1;

                          // console.log(currentBookingInfo,"currentBookingTOtalRate")
                          return (
                            <div
                              key={`${roomIndex}-${rateTypeIndex}`}
                              className="room_rate_card_container_outsider mb-2"
                            >
                              <>
                                <p className="m-0 room_rate_name_text">
                                  {Array.from(
                                    new Set(
                                      rateType?.rateplans
                                        ?.map((plan) => plan?.title)
                                        .filter(Boolean)
                                    )
                                  ).join(", ") || "No Title"}
                                </p>

                                {/* <p className="room_units_text">
                          {totalRoomUnitAvailable
                            ? `${totalRoomUnitAvailable} units available`
                            : "No units available"}
                        </p> */}
                                <div className="room_rate_card_container">
                                  <div
                                    className="col-md-6 p-0 "
                                    style={{ position: "relative" }}
                                  >
                                    {/* <p className="room_rate_text_self">
                                Room maximum capacity
                              </p>
                              <div className="img_adult_child_container">
                                <i className="fa fa-male" aria-hidden="true" />{" "}
                                <span>{adult} </span>
                                <i className="fa fa-solid fa-child" />
                                <span>{child}</span>
                              </div> */}

                                    {/* <div
                                style={{
                                  height:
                                    showRoomBtn[countKey] !== false ? 200 : 100,
                                }}
                              ></div> */}

                                    {currentBookingInfo?.total > 0 ? (
                                      <>
                                        <p className="room_rate_text_self mt-5">
                                          Room
                                        </p>

                                        <div className="quantity_container">
                                          <button
                                            className="minus_btn"
                                            onClick={() =>
                                              handleMinus(room, rateType)
                                            }
                                          >
                                            -
                                          </button>
                                          <p>{roomQuantityCount}</p>
                                          <button
                                            className="plus_btn"
                                            disabled={
                                              roomQuantityCount >=
                                              totalRoomUnitAvailable
                                            } // Disable if limit reached
                                            onClick={() =>
                                              handlePlus(room, rateType)
                                            }
                                          >
                                            +
                                          </button>
                                        </div>
                                      </>
                                    ) : null}

                                    <div className="popover_container">
                                      {/* <p
                                  className="free_cancallation_btn"
                                  // onMouseEnter={() => setIsHovered(true)}
                                  // onMouseLeave={() => setIsHovered(false)}
                                >
                                  Room Rates Exclusive of Tax
                                </p> */}
                                      {/* {showRoomBtn[countKey] !== false && <br/> } */}

                                      {isHovered && (
                                        <div className="popover_hover_box">
                                          <p
                                            className="popover_text"
                                            dangerouslySetInnerHTML={{
                                              __html: `This booking is non-refundable and the tariff cannot be cancelled with zero fee.`,
                                            }}
                                          ></p>
                                        </div>
                                      )}
                                    </div>
                                    <p
                                      className="free_cancallation_btn"
                                      // onMouseEnter={() => setIsHovered(true)}
                                      // onMouseLeave={() => setIsHovered(false)}
                                    >
                                      Room Rates Exclusive of Tax
                                    </p>
                                    <p className="special_highlight_txt">
                                      {/* {room?.specialhighlightinclusion} */}
                                      {specialhighlightinclusion}
                                    </p>
                                    <button
                                      className={
                                        showRoomBtn[countKey] !== false
                                          ? "more_details_btn more_details_btn1"
                                          : "more_details_btn"
                                      }
                                      onClick={() => handleMoreDetails(room)}
                                    >
                                      Room Info
                                    </button>
                                    <br />
                                    <label>
                                      <input
                                        checked={clickCompare.some(
                                          (r) => r.countKey === countKey
                                        )}
                                        disabled={
                                          clickCompare.length >= 4 &&
                                          !clickCompare.some(
                                            (r) =>
                                              r?.countKey === countKey
                                          )
                                        }
                                        type="checkbox"
                                        id="myCheckbox"
                                        onChange={() =>
                                          handleCheckBoxChange(room, countKey)
                                        }
                                      />
                                      &nbsp;
                                    </label>
                                    {clickCompare.some(
                                      (r) => r.countKey === countKey
                                    ) ? (
                                      <span
                                        style={{ fontSize: 14,color:"green",fontWeight:"500",cursor:"pointer" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openModalClickToCompare(room);
                                        }}
                                      >
                                        Click to compare
                                      </span>
                                    ) : (
                                      <span
                                        style={{ fontSize: 14,cursor:"pointer" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openModalClickToCompare(room);
                                        }}
                                      >
                                        Add to compare
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-md-6 p-0 price_night_adult_child_container">
                                    <div className="price_rate_total_adult_per_night_container">
                                      <p>
                                        {getCurrency()}&nbsp;
                                        {CurrencyFormatter(
                                          activeTab === "night"
                                            ? (currentBookingInfo?.actualCost >
                                              0
                                                ? currentBookingInfo.actualCost /
                                                  nightsCount
                                                : rateType?.rateplans.reduce(
                                                    (acc, ratePlan) =>
                                                      acc +
                                                      parseFloat(
                                                        ratePlan?.rate?.Base
                                                      ),
                                                    0
                                                  ) / nightsCount
                                              ).toFixed(2)
                                            : currentBookingInfo?.actualCost > 0
                                            ? currentBookingInfo.actualCost.toFixed(
                                                2
                                              )
                                            : rateType?.rateplans
                                                .reduce(
                                                  (acc, ratePlan) =>
                                                    acc +
                                                    parseFloat(
                                                      ratePlan?.rate?.Base
                                                    ),
                                                  0
                                                )
                                                .toFixed(2),
                                          locale || "en-IN",
                                          currency || "INR"
                                        )}
                                        &nbsp;
                                        {/* <div className="popover_container"> */}
                                        <button
                                          className="free_cancallation_btn"
                                          onClick={() =>
                                            handleOpenRateModal(rateType)
                                          }
                                          // onMouseEnter={() => setHoverPrice(true)}
                                          // onMouseLeave={() => setHoverPrice(false)}
                                        >
                                          <i
                                            className="fa fa-info-circle"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      </p>
                                      {nightsPerDateCount?.length && (
                                        <p className="price_per_night_text">
                                          Price for {nightsPerDateCount?.length}{" "}
                                          {nightsPerDateCount?.length > 1
                                            ? "Nights"
                                            : "Night"}
                                        </p>
                                      )}
                                      <p>{`${adults} Adults, ${children} ${
                                        room?.minnights > nightsCount
                                          ? "Child"
                                          : "Children"
                                      }, ${rooms} Room`}</p>
                                    </div>
                                    {/* {countRoom && countRoom[`${room?.serviceId}-${rateType?.ratetypename}`] < 0 && ( */}

                                    {showRoomBtn[countKey] !== false && (
                                      <button
                                        className="add_room_btn recommended_txt"
                                        onClick={() =>
                                          handleAddRoom(room, rateType)
                                        }
                                      >
                                        Add Room
                                      </button>
                                    )}

                                    {room?.minnights > nightsCount && (
                                      <p className="mb-0 mt-2 text-danger font-14 ">
                                        {`You need ${
                                          room?.minnights - nightsCount
                                        } more night to book this room.`}
                                      </p>
                                    )}

                                    {/* )} */}

                                    <p className="room_available_text">
                                      {availableRooms[countKey?.slice(0, 24)] ??
                                        totalRoomUnitAvailable}
                                      &nbsp;
                                      {totalRoomUnitAvailable > 1
                                        ? "Rooms"
                                        : "Rooms"}{" "}
                                      available
                                    </p>
                                  </div>
                                </div>

                                <div className="room_adult_child_container">
                                  {bookingPayload?.bookingdetail?.occupants
                                    ?.filter((occupant) => {
                                      if (
                                        occupant?.ratetype !==
                                          rateType?.ratetypeid ||
                                        occupant?.refid !== room?.serviceId
                                      ) {
                                        return false;
                                      }
                                      return true;
                                    })
                                    .map((occupant, index) => {
                                      return (
                                        <AdultChildRoomSelector
                                          key={occupant?.unitid}
                                          bookingInfo={occupant}
                                          roomName={`Room ${index + 1}`}
                                          maxAdults={
                                            room?.property
                                              ?.max_adult_occupancy ??
                                            room?.capacity?.adult ??
                                            0
                                          }
                                          maxChildren={
                                            room?.property
                                              ?.max_child_occupancy ??
                                            room?.capacity?.child ??
                                            0
                                          }
                                          onChange={(data) =>
                                            handleRoomDataUpdate(
                                              room,
                                              rateType,
                                              index,
                                              data,
                                              occupant
                                            )
                                          }
                                        />
                                      );
                                    })}
                                </div>
                                <hr className="m-0" />
                              </>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

          </>

            <div className="room_box_sidebar_container w-100">
              {bookingPayload?.checkin != "" && (
                <>
                  <div className="sidebar_booking_room_container w-100">
                    <div className="title_booking_details_text_container">
                      <p>Booking details</p>
                    </div>

                    <SidebarBooking
                      bookingInfo={bookingPayload}
                      roomRate={storeRoomData}
                      sameBooking={identifySameRoomBookings}
                      onBook={handleOnBook}
                      // setIdentifySameRoomBookings={setIdentifySameRoomBookings}
                    />
                  </div>

                  <CustModal
                    modalWidthSize={"xl"}
                    show={showModal}
                    footerBtn={false}
                    handleClose={handleMoreDetailsClose}
                    title={selectedModalRoomData?.name || "Room details"}
                    body={
                      <RoomModalDetails
                        termsData={policyStoreData?.property}
                        data={{
                          ...selectedModalRoomData,
                          checkInDate: [bookingPayload?.checkin],
                          checkOutDate: [bookingPayload?.checkout],
                        }}
                      />
                    }
                    footerBtnName="Close"
                    handleSubmit={handleMoreDetailsClose}
                  />

                  <CustModal
                    footerBtnNameterBtn={true}
                    modalWidthSize={"lg"}
                    show={showPriceTableModal}
                    handleClose={() => setShowPriceTableModal(false)}
                    title="Per day price breakdown (All Taxes Exclusive)"
                    body={
                      <>
                        <h6 className="text-decoration-underline">
                          {/* Extra Adult price : ₹ 2500{" "} */}
                        </h6>
                        <table className="table table-bordered table-striped">
                          <thead className="thead-dark">
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Rates</th>
                              <th scope="col">Extra adult rates</th>
                              <th scope="col">Extra child rates</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(selectedRateTypeData).length === 0
                              ? null
                              : selectedRateTypeData?.rateplans.map(
                                  (item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          {formatDate(item?.date)}
                                          {/* {resetToMidnightFormatted(item?.date)} */}
                                          {/* {new Date(item.date).toDateString()} */}
                                        </td>
                                        <td width={180}>
                                          {getCurrency()} {item?.rate?.Base === 0 ? 0 : item?.rate?.Base?.toFixed(2)}
                                        </td>
                                        <td width={180}>
                                          {getCurrency()}{" "}
                                          {item?.rate?.ExtraAdult === 0 ? 0 : item?.rate?.ExtraAdult?.toFixed(2)}
                                        </td>
                                        <td width={180}>
                                          {getCurrency()}{" "}
                                          {item?.rate?.ExtraChild === 0 ? 0 : item?.rate?.ExtraChild?.toFixed(2)}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                          </tbody>
                        </table>
                      </>
                    }
                    footerBtnName="Close"
                    handleSubmit={() => setShowPriceTableModal(false)}
                  />

                  {/* compare rooms */}

                  <CustModal
                    footerBtnNameterBtn={true}
                    modalWidthSize={"xl"}
                    show={openModalCompare}
                    handleClose={handleCloseModalCompare}
                    title="Compare Rooms"
                    body={
                      <>
                        <TableCompare services={clickCompare} />
                      </>
                    }
                    footerBtnName="Close"
                    handleSubmit={() => setOpenModalCompare(false)}
                  />

                  {/* filter rooms */}

                  <CustModal

                  footerBtn={true}
                    modalWidthSize={"md"}
                    show={openFilter}
                    handleClose={() => {
                      setOpenFilter(false)
                      setStoreRoomData(rateRoomData)
                    }}
                    title="Filter"
                    body={
                      <>
                        <Filter
                          handlePassMultiCheckBox={handlePassMultiCheckBox}
                          rooms={storeRoomData}
                          handleSelectDrop={handleFilterRooms}
                        />
                      </>
                    }

                    footerBtnName="Apply"
                    handleSubmit={handleApply}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
